import {
  ProviderResourcesCollapsibleContainerConnected,
  useGetClientHasTherapyToolkitEnabled,
} from "@grow-therapy-team/seedling-components";
import { useAtomValue } from "jotai";
import {
  isSelectedClientUserMinorAtom,
  isSelectedPatientEnrolledInStructuredCareProgram,
  providerShortIdAtom,
  selectedClientUserShortIdAtom,
} from "../state";

export function ProviderResourcesCollapsibleContainerWrapper() {
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? "";
  const providerShortId = useAtomValue(providerShortIdAtom) ?? "";

  const { data: clientHasTherapyToolkitEnabledData } =
    useGetClientHasTherapyToolkitEnabled(clientUserShortId);
  const isTherapyToolkitFeatureEnabled =
    clientHasTherapyToolkitEnabledData?.clientHasTherapyToolkitEnabled;
  const isPatientEnrolledInStructuredCareProgram = useAtomValue(
    isSelectedPatientEnrolledInStructuredCareProgram,
  );
  const isClientUserMinor = useAtomValue(isSelectedClientUserMinorAtom);
  if (!isTherapyToolkitFeatureEnabled) return null;

  return (
    <ProviderResourcesCollapsibleContainerConnected
      clientUserShortId={clientUserShortId}
      providerShortId={providerShortId}
      isHidden={isClientUserMinor}
      isPatientEnrolledInStructuredCareProgram={
        isPatientEnrolledInStructuredCareProgram
      }
    />
  );
}
